import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";
import useTiempoRecoleccionProvincia from "../../../hooks/administrador/recoleccion/useTiempoRecoleccionProvincia";
import '../../../styles/administrador.css';



const TiempoRecoleccionProvincia = ({ year, mes, token, idAdministrador, provinciaSeleccionada, ciudadSeleccionada }) => {
  const chartRef = useRef(null);
  const { data, loading, error } = useTiempoRecoleccionProvincia(
    year, 
    mes, 
    token, 
    idAdministrador,
    provinciaSeleccionada,
    ciudadSeleccionada
  );

  useEffect(() => {
    if (loading || error || !chartRef.current) return;
    
    if (!Array.isArray(data) || data.length === 0) {
      return;
    }

    const chartDom = chartRef.current;
    let myChart = echarts.getInstanceByDom(chartDom) || echarts.init(chartDom);
    if (myChart) myChart.dispose();
    myChart = echarts.init(chartDom);

    const top10Data = [...data].sort((a, b) => parseFloat(b.tiempo) - parseFloat(a.tiempo)).slice(0, 10);

    const option = {
      title: {
        text: 'Tiempo promedio de recolección ',
        left: 'center',
        subtext: 'SEGMENTADO POR PROVINCIA',
        subtextStyle: {
          fontSize: '12px',
          fontWeight: 'bold'
        },
      },
      tooltip: {
        confine: true,
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        },
        formatter: function(params) {
          return `${params[0].name}<br/>${params[0].seriesName}: ${params[0].value.toFixed(2)} días`;
        }
      },
      grid: {
        left: '5%',
        right: '10%',
        bottom: '10%',
        containLabel: true
      },
      yAxis: {
        type: 'category',
        data: top10Data.map(item => item.descripcion),
        axisLabel: {
          rotate: 0,
          interval: 0,
          fontWeight: 'bold',
          formatter: function(value) {
            return value.length > 11 ? value.substring(0, 10) + '...' : value;
          }
        }
      },
      xAxis: {
        type: 'value',
        name: 'Días',
        axisLabel: {
          formatter: function(value) {
            return value.toFixed(2);
          }
        }
      },
      series: [{
        name: 'Tiempo Promedio',
        type: 'bar',
        data: top10Data.map(item => parseFloat(item.tiempo)),
        itemStyle: {
          color: function(params) {
            const colorPalette = ['#d1dc5a', '#6ac5cb', '#45444e', '#a3b85b', '#3a6b74'];
            return colorPalette[params.dataIndex % colorPalette.length];
          }
        }
      }]
    };

    myChart.setOption(option);
    
    const updateChart = () => {
      myChart.resize();
    };
    
    window.addEventListener('resize', updateChart);
    
    return () => {
      window.removeEventListener('resize', updateChart);
      if (myChart && !myChart.isDisposed()) {
        myChart.dispose();
      }
    };
  }, [data, loading, error]);

  if (loading) {
    return <div className="grafica loading">Cargando datos de tiempo por provincia...</div>;
  }

  if (error) {
    return (
      <div className="grafica error">
        <p>Error al cargar datos de tiempo por provincia</p>
        <small>Detalles: {error.message || "Error desconocido"}</small>
      </div>
    );
  }

  return <div className="grafica" ref={chartRef}></div>;
};

export default TiempoRecoleccionProvincia;